import React, { CSSProperties, useMemo } from 'react'
import { TreeSelect as TTreeSelect } from './treeselect'

// const { SHOW_PARENT } = AntTreeSelect

export interface MenuItem {
  value: number
  label: string | React.ReactNode
  disabled?: boolean
  children?: MenuItem[]
  isLeaf?: boolean
}

interface TreeSelectProps {
  label: string
  items: MenuItem[]
  onChange: (newValue: any, selectedOptions?: any) => void
  size?: 'small' | 'middle' | 'large'
  showError?: boolean
  invalidMessage?: string
  className?: string
  style?: CSSProperties
  defaultValue?: number[]
  value?: number[] | (string | number)[]
  onClear?: () => void
  onDropdownVisibleChange?: (open: boolean) => void
  isRTL?: boolean
  useNew?: boolean
}

export default function TreeSelect({ label, items, size, showError, invalidMessage, className, onChange, defaultValue, value, onClear, onDropdownVisibleChange, useNew, isRTL = false, }: TreeSelectProps) {

  const treeData = useMemo((): any[] => {
    return items.map((item) => ({
      title: item.label,
      value: item.value,
      children: item.children ? menuItemToTreeDataRecursive(item.children, item) : undefined,
    }))
  }, [items])

  function menuItemToTreeDataRecursive(children: MenuItem[], parent: MenuItem): any[] {
    return children.map((child) => ({
      title: child.label,
      value: `${parent.value}-${child.value}`,
    }))
  }

  function filterTreeNode(inputValue: string, treeNode?: any): boolean {
    return treeNode.title.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
  }

  return <div className={className}>
    <div className={`mb-2 ${isRTL ? 'rtl-label' : ''}`}
      style={isRTL ? { textAlign: 'right', direction: 'rtl' } : undefined}>
      {label}
    </div>
    <TTreeSelect
      className="w-full"
      onChange={onChange}
      treeData={treeData}
      defaultValue={defaultValue}
      value={value}
      onDropdownVisibleChange={onDropdownVisibleChange}
      filterTreeNode={filterTreeNode}
    />
    {showError && (
      <div className='text-red-500 text-xs mt-1 ml-1'>
        {invalidMessage} Error
      </div>
    )}
  </div>

}
